export default (args) => {
  var obj = {}, i = args.length
  while (i--) {
    obj[args[i]] = args[i]
  }
  return obj
}
